import { Box } from '@mui/material'
import React from 'react'

function NotFound() {
  return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
    >
        <Box
            sx={{
                fontSize: 32,
                fontWeight: 'bold',
                mb: 2,
                textAlign: 'center',
            }}
        >
            Page non trouvée
        </Box>
        <Box color="text.secondary" textAlign="center">
            La page que vous cherchez n'existe pas ou a été déplacée
        </Box>
    </Box>
  )
}

export default NotFound